import crudlModuleGenerator from '@/_CRUDL/modules/generator';

export default crudlModuleGenerator('customersGuarantors', {
  customEndpoints: {
    delete: '/customers/:id/guarantors/:delete',
  },
});
